import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';

import {Group} from '../../../graphql/groups.datatypes';

interface GroupsData {
    allGroups: Group[]
}

export const GET_ALL_GROUPS_QUERY = gql`
  query allGroups($where: WhereConditions, $orderBy: [OrderByClause!]){
    allGroups(where: $where, orderBy: $orderBy){
      id
      name
    }
  }
`;

export const getAllGroups = (where?: any, orderBy?: any) => useQuery<GroupsData>(
  GET_ALL_GROUPS_QUERY,
  {
    variables: {
      where,
      orderBy,
    },
    
  }
);

export default getAllGroups;